import { InjectionToken } from '@angular/core';

/** Si es `false`, no se llama a POST/PUT/DELETE `/api/admin/user-tenants` (API legacy sin ese módulo). */
export const VAULT_ADMIN_USER_TENANTS_API_ENABLED = new InjectionToken<boolean>(
  'VAULT_ADMIN_USER_TENANTS_API_ENABLED',
  { factory: () => true },
);
